import "./Header.css";
import React, { useEffect } from "react";
import { logData } from "../api.js";


const Header = ({ showAskAnythingDialog }) => {
    let startTime = new Date().getTime();

    const handleLinkClick = (event) => {
        event.preventDefault();
        showAskAnythingDialog();
    };

    const logReferrer = () => {
        const referrer = document.referrer || "No referrer";
        const extraData = { referrer: referrer };

        logData("visit", extraData)
            .catch(() => {

            });
    };

    const logTimeSpent = () => {
        const endTime = new Date().getTime();
        const timeSpent = Math.round((endTime - startTime) / 1000);
        logData("duration", timeSpent.toString())
            .catch(() => {

            });
    };

    useEffect(() => {
        logReferrer();

        window.addEventListener("beforeunload", logTimeSpent);

        return () => {
            window.removeEventListener("beforeunload", logTimeSpent);
        };
    }, []);


    return (
        <header className="lp-header">
            <div className="lp-header__inner">
                <a className="lp-header__brand" href="/">
                    <span className="lp-header__name">Viorel Spînu</span>
                    <span className="lp-header__sub">Curs gratuit de AI</span>
                </a>
                <button type="button" className="lp-header__ask" onClick={handleLinkClick} id="askAnythingButton">
                    Întreabă-mă orice
                </button>
            </div>
        </header>
    );
}

export default Header;
